import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from 'pages/PageNotFound'
import Index from 'pages/PageIndex'
import Home from 'pages/PageHome'
import RoomList from 'pages/PageRoomList'
import RoomTrigger from 'pages/PageRoomTrigger'
import RoomSession from 'pages/PageRoomSession'
import ShopOrderList from 'pages/PageShopOrderList'
import GameUserList from 'pages/PageGameUserList'
import GameUserCoinJournal from 'pages/PageGameUserCoinJournal'
import UserPassword from 'pages/PageUserPassword'
import Application from 'pages/PageApplication'
import store from '../store'

import $ from 'jquery'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: PageNotFound,
    meta: {
      layout: 'none',
      title: '404-页面丢了',
      bodyClass: 'layout-top-nav fixed'
    }
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Index,
    meta: {
      layout: 'none',
      title: '登录',
      bodyClass: 'login-page'
    }
  },
  {
    path: '/home',
    component: Home,
    meta: {}
  },
  {
    path: '/rooms',
    component: RoomList,
    meta: {}
  },
  {
    path: '/rooms/trigger',
    component: RoomTrigger,
    meta: {}
  },
  {
    path: '/shop/orders',
    component: ShopOrderList,
    meta: {}
  },
  {
    path: '/rooms/sessions',
    component: RoomSession,
    meta: {}
  },
  {
    path: '/gameusers',
    component: GameUserList,
    meta: {}
  },
  {
    path: '/gameusers/coin/journal',
    component: GameUserCoinJournal,
    meta: {}
  },
  {
    path: '/user/password',
    component: UserPassword,
    meta: {}
  },
  {
    path: '/application',
    component: Application,
    meta: {}
  }
]
const router = new VueRouter({
  base: '/shopadmin/',
  routes: routes
})
/**
 * 获取导航路径
 */
let getNavIndexPath = function (url, parentNav, onlyIndex = true) {
  let paths = [];
  let childPaths = [];
  for (let i in parentNav) {
    let row = parentNav[i];
    let index = i;
    if (row.childrens !== undefined && row.childrens.length > 0) {
      // 搜索儿子
      childPaths = getNavIndexPath(url, row.childrens, onlyIndex);
      if (childPaths.length > 0) {
        if (onlyIndex) {
          paths.push(index)
        } else {
          paths.push(row)
        }
        paths = paths.concat(childPaths);
        break;
      }
    } else if (url === row.url) {
      if (onlyIndex) {
        paths.push(index)
      } else {
        paths.push(row)
      }
      break;
    }
  }
  return paths;
}
router.beforeEach((to, from, next) => {
  if (!to.meta.title) {
    let paths = getNavIndexPath(to.path, store.state.navigation, false);
    to.meta.title = paths.pop().name
  }
  if (!to.meta.layout) {
    to.meta.layout = 'main'
  }
  document.title = to.meta.title
  if (!to.meta.bodyClass) {
    to.meta.bodyClass = 'sidebar-mini skin-yellow';
  }
  if (to.path === '/login' || (store.state.User.isLogin && store.state.User.user)) {
    next()
    return
  }
  Vue.http.get('/api/me').then(resp => {
    if (resp.data.errcode !== 0) {
      store.dispatch('setUser', null)
      next('/login')
      return
    }
    store.dispatch('setUser', resp.data.user)
    next()
  }).catch((error) => {
    console.log(error)
    store.dispatch('setUser', null)
    next('/login')
  })
})

router.beforeResolve((to, from, next) => {
  /**
   * 根据路径设置页面基础数据
   */
  let setPageData = function (paths, parentNav) {
    var index = paths[0];
    if (paths.length <= 0) {
      return false;
    }
    if (paths.length === 1) {
      pageData.title = parentNav[index].name;
    } else if (paths.length > 1) {
      setPageData(paths.splice(1, paths.length - 1), parentNav[index].childrens);
    }
    pageData.pathlist.push(parentNav[index]);
  }
  let paths = getNavIndexPath(to.path, store.state.navigation);
  let pageData = {title: '', brief: '', pathlist: []};
  setPageData(paths, store.state.navigation);
  pageData.pathlist = pageData.pathlist.reverse();
  store.commit('setPageData', pageData)
  next()
})
router.afterEach((to, from) => {
  if ($.AdminLTE && $.AdminLTE.layout) {
    // nextTick 回调会在DOM更新完毕后再执行
    Vue.nextTick(() => {
      $.AdminLTE.layout.activate();
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js